module.exports = __webpack_public_path__ + "img/product04-ABS.3b87e873.svg";